const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/location/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/lib/hooks/common/usePermissions';
import i18n from '@/lib/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/settings/location')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: requirePermission('edit_teams'),
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.common.settings.location.location.label)
  })
});